import { gql } from '@apollo/client';

export const CREATE_TMS_TEMPORARY_TASK = gql`
    mutation CreateTmsTask($input: CreateTmsTaskInput!) {
        createTmsTask(input: $input) {
            success
            code
            message
            argsJson
        }
    }
`;

export const UPDATE_TMS_TASK = gql`
    mutation UpdateTmsTask($id: ID!, $input: UpdateTmsTaskInput!) {
        updateTmsTask(id: $id, input: $input) {
            success
            code
            message
            argsJson
        }
    }
`;

// 转运信息独立保存（任务未完成即可编辑，发布后前端转运区单独入口用）
export const UPDATE_TMS_TASK_TRANSIT_INFOS = gql`
    mutation UpdateTmsTaskTransitInfos($input: UpdateTmsTaskTransitInfosInput!) {
        updateTmsTaskTransitInfos(input: $input) {
            success
            code
            message
            argsJson
        }
    }
`;

export interface UpdateTmsTaskTransitInfosResponse {
    updateTmsTaskTransitInfos: {
        success: boolean;
        code: string;
        message: string;
        argsJson?: string | null;
    };
}

// 是否散货拼车独立保存（任务未完成即可编辑，发布后前端单独入口用）
export const UPDATE_TMS_TASK_BULK_CONSOLIDATED = gql`
    mutation UpdateTmsTaskBulkConsolidated($input: UpdateTmsTaskBulkConsolidatedInput!) {
        updateTmsTaskBulkConsolidated(input: $input) {
            success
            code
            message
            argsJson
        }
    }
`;

export interface UpdateTmsTaskBulkConsolidatedInput {
    taskId: number;
    isBulkConsolidated: boolean;
}

export interface UpdateTmsTaskBulkConsolidatedResponse {
    updateTmsTaskBulkConsolidated: {
        success: boolean;
        code: string;
        message: string;
        argsJson?: string | null;
    };
}

export const CANCEL_TMS_TASK = gql`
    mutation CancelTmsTask($id: ID!, $cancelReason: String!, $cancelCost: Long!) {
        cancelTmsTask(id: $id, cancelReason: $cancelReason, cancelCost: $cancelCost) {
            success
            code
            message
            argsJson
        }
    }
`;

export const DELETE_TMS_TASK = gql`
    mutation DeleteTmsTask($id: ID!) {
        deleteTmsTask(id: $id)
    }
`;

export const BATCH_PUBLISH_TMS_TASKS = gql`
    mutation BatchPublishTmsTasks($taskIds: [ID!]!) {
        batchPublishTasks(taskIds: $taskIds) {
            id
            taskNumber
            taskType
            taskDate
            taskStatus
            routeId
            routeType
            planDepartureDate
            planDepartureTime
            actualDepartureDate
            actualDepartureTime
            actualDepartureAt
            planArrivalDate
            planArrivalTime
            actualArrivalDate
            actualArrivalTime
            actualArrivalAt
            carrierId
            carrierName
            driver1Id
            driver1Name
            driver1PhoneNumber
            driver2Id
            driver2Name
            driver2PhoneNumber
            vehicleId
            licensePlate
            publishedAt
            completedAt
            createdAt
            updatedAt
        }
    }
`;

export const HANDLE_TMS_WHS_SEALED_SCAN_EVENT_FOR_PORTAL = gql`
    mutation HandleTmsWhsSealedScanEventForPortal($input: HandleTmsWhsSealedScanEventInput!) {
        handleTmsWhsSealedScanEventForPortal(input: $input) {
            success
            message
        }
    }
`;

export const HANDLE_TMS_WHS_UNSEALING_SCAN_EVENT_FOR_PORTAL = gql`
    mutation HandleTmsWhsUnsealingScanEventForPortal($input: HandleTmsWhsUnsealingScanEventInput!) {
        handleTmsWhsUnsealingScanEventForPortal(input: $input) {
            success
            message
        }
    }
`;

export const SUBMIT_TMS_WHS_UNSEALING_SCAN_EVENT_FOR_PORTAL = gql`
    mutation SubmitTmsWhsUnsealingScanEventForPortal($input: HandleTmsWhsUnsealingScanEventInput!) {
        submitTmsWhsUnsealingScanEventForPortal(input: $input) {
            success
            message
        }
    }
`;

export const UPDATE_TMS_TASK_WAYPOINT_TO_ARRIVED_FOR_PORTAL = gql`
    mutation UpdateTmsTaskWaypointToArrivedForPortal($input: UpdateTmsTaskWaypointToArrivedInput!) {
        updateTmsTaskWaypointToArrivedForPortal(input: $input)
    }
`;

export const UPDATE_TMS_TASK_WAYPOINT_TO_DEPARTURE_FOR_PORTAL = gql`
    mutation UpdateTmsTaskWaypointToDepartureForPortal($input: UpdateTmsTaskWaypointToDepartureInput!) {
        updateTmsTaskWaypointToDepartureForPortal(input: $input) {
            success
            code
            message
        }
    }
`;

export type { ApiResult } from '../../../../../graphql/types/ApiResult';

export const SAVE_TMS_LOADING_DETAIL_INFO = gql`
    mutation SaveTmsLoadingDetailInfoForPortal($input: SaveTmsLoadingDetailInfoInput!) {
        saveTmsLoadingDetailInfoForPortal(input: $input)
    }
`;

export const SAVE_TMS_UNLOADING_DETAIL_INFO = gql`
    mutation SaveTmsUnloadingDetailInfoForPortal($input: SaveTmsUnloadingDetailInfoInput!) {
        saveTmsUnloadingDetailInfoForPortal(input: $input)
    }
`;

export interface SaveTmsUnloadingDetailInfoItemInput {
    containerType?: number | null;
    containerCount: number;
    sortingCode?: string | null;
}

export interface SaveTmsUnloadingDetailInfoInput {
    taskId: number;
    taskWaypointId: number;
    items: SaveTmsUnloadingDetailInfoItemInput[];
    bolRemark?: string | null;
    bolPhotosJson?: string[] | null;
    unloadingLocalTime?: string | null;
    operationSource?: number; // 操作来源：1-APP司机端，2-PDA，3-PC服务端
}

// 干线卸车保存（公共逻辑 + 包牌已卸标记）；支线入库/PDA 用 saveTmsUnloadingDetailInfo（PC管理后台专属）
export const SAVE_UNLOADING_DETAIL_INFO_FOR_PORTAL = gql`
    mutation SaveUnloadingDetailInfoForPortal($input: SaveUnloadingDetailInfoInput!) {
        saveUnloadingDetailInfoForPortal(input: $input)
    }
`;

export interface SaveUnloadingDetailInfoInput {
    taskId: number;
    taskWaypointId: number;
    bolRemark?: string | null;
    bolPhotosJson?: string[] | null;
    unloadingLocalTime?: string | null;
    operationSource?: number; // 操作来源：1-APP司机端，2-PDA，3-PC服务端
    addedBagNumbers?: string[];        // 新增标记为本站已卸的包牌号
    addedTrackingNumbers?: string[];   // 新增标记为本站已卸的运单号
    removedBagNumbers?: string[];      // 取消本站已卸标记的包牌号
    removedTrackingNumbers?: string[]; // 取消本站已卸标记的运单号
}

export interface SaveTmsTaskContainerInfoItemInput {
    destinationWarehouseId?: number | null;
    sortingCode?: string | null;
    containerType?: number | null;
    containerCount: number;
}

export interface SaveTmsLoadingDetailInfoInput {
    taskId: number;
    taskWaypointId: number;
    warehouseId?: number | null;
    items: SaveTmsTaskContainerInfoItemInput[];
    loadingInfoRemark?: string | null;
    loadingInfoInteriorPhotosJson?: string[] | null;
    loadingLocalTime?: string | null;
    addedItems?: HandleBatchTmsLoadingEventItemInput[];
    removedItems?: HandleBatchTmsLoadingEventItemInput[];
    operationSource?: number; // 操作来源：1-APP司机端，2-PDA，3-PC服务端
}

export interface HandleBatchTmsLoadingEventItemInput {
    isBag: boolean;
    barCode: string;
    parcelQuantity?: number | null;
    destinationWarehouseId?: number | null;
    destinationSortingCode?: string | null;
}

// 创建任务时附带的临时司机信息（由 createTmsTask 内部创建）
export interface TmsTaskTemporaryDriverInput {
    name: string;
    countryCode?: number;
    phone?: string | null;
    password?: string | null;
    email?: string | null;
    role?: string;
    status?: number;
    carrierId: number;
    vehicleId?: number | null;
}

// 创建任务时附带的临时车辆信息（由 createTmsTask 内部创建）
export interface TmsTaskTemporaryVehicleInput {
    licensePlate: string;
    carrierId: number;
    vehicleTypeId: number;
    maxWeightLbs?: number | null;
    maxVolumeFt3?: number | null;
    lengthFt?: number | null;
    widthFt?: number | null;
    heightFt?: number | null;
    fuelType?: number | null;
    status?: number;
    vehiclePhotos?: string[] | null;
}

// 创建TMS任务的输入类型
export interface CreateTmsTaskInput {
    taskSource: number; // 1-系统创建，2-人工创建
    businessType: number; // 1-自有路线，2-TikTok，3-Temu GA
    taskType: number; // 1-常规，2-临时
    taskDate: string; // yyyy-MM-dd
    taskStatus?: number; // 默认1-draft
    routeId: number;
    routeName: string; // 路线名称
    warehouseId: number; // 任务所属warehouse
    planDepartureDate?: string | null;
    planDepartureTime?: string | null;
    actualDepartureDate?: string | null;
    actualDepartureTime?: string | null;
    actualDepartureAt?: string | null;
    planArrivalDate?: string | null;
    planArrivalTime?: string | null;
    actualArrivalDate?: string | null;
    actualArrivalTime?: string | null;
    actualArrivalAt?: string | null;
    carrierId: number;
    driver1Id?: number; // 司机1系统ID（可选，临时司机时为空）
    driver1Name?: string | null; // 司机1姓名
    driver1PhoneNumber?: string | null; // 司机1联系方式
    driver2Id?: number | null; // 司机2系统ID（可选，自由输入姓名时为空）
    driver2Name?: string | null; // 司机2姓名（非必填，仅BOL展示）
    driver2PhoneNumber?: string | null; // 司机2联系方式（非必填）
    vehicleId?: number; // 车辆ID（可选，自由输入时为空）
    temporaryDriver1?: TmsTaskTemporaryDriverInput | null;
    temporaryDriver2?: TmsTaskTemporaryDriverInput | null; // 临时司机2（与 driver2Id 二选一，后端建司机账号） // 临时司机信息（与 driver1Id 二选一）
    temporaryVehicle?: TmsTaskTemporaryVehicleInput | null; // 临时车辆信息（与 vehicleId 二选一）
    trailerNumber?: string | null;
    escortCount?: number | null;
    perVehicleCost?: number | null;
    gpsTracking?: string | null;
    licensePlate?: string | null;
    vehicleTypeId?: number | null;
    remark?: string | null;
    publishedAt?: string | null;
    completedAt?: string | null;
    // 转运信息（仅干线+自有路线任务适用）：不传=不处理，[]=无转运，非空=按此写入
    transitInfos?: TmsTaskTransitInfoInput[] | null;
    // 是否散货拼车
    isBulkConsolidated?: boolean | null;
}

export interface UpdateTmsTaskInput {
    driver1Id?: number | null;
    driver1Name?: string | null;
    driver1PhoneNumber?: string | null;
    // 司机2：非必填，仅BOL展示。注意后端是全量覆盖，编辑时必须一并回传，否则已有司机2 会被清空
    driver2Id?: number | null;
    driver2Name?: string | null;
    driver2PhoneNumber?: string | null;
    vehicleId?: number | null;
    trailerNumber?: string | null;
    remark?: string | null;
    taskStatus?: number | null;
    escortCount?: number | null;
    perVehicleCost?: number | null;
    gpsTracking?: string | null;
    temporaryDriver1?: TmsTaskTemporaryDriverInput | null;
    temporaryDriver2?: TmsTaskTemporaryDriverInput | null; // 临时司机2（与 driver2Id 二选一，后端建司机账号）
    temporaryVehicle?: TmsTaskTemporaryVehicleInput | null;
    licensePlate?: string | null;
    vehicleTypeId?: number | null;
    // 交接方类型（1-本地尾程商 2-干线承运商）：前端回传，供后端判断本地尾程商交接任务可在任意状态编辑
    carrierSourceType?: number | null;
    // 转运信息：不传=本次不处理；[]=清空；非空=全量替换
    transitInfos?: TmsTaskTransitInfoInput[] | null;
    // 是否散货拼车
    isBulkConsolidated?: boolean | null;
}

export interface TmsTaskTransitInfoInput {
    transitWarehouseId: number;
    transitDestWarehouseId: number;
}

export interface CreateTmsTaskResponse {
    createTmsTask: {
        success: boolean;
        code: string;
        message: string;
        argsJson?: string | null;
    };
}

export interface UpdateTmsTaskResponse {
    updateTmsTask: {
        success: boolean;
        code: string;
        message: string;
        argsJson?: string | null;
    };
}

export interface CancelTmsTaskResponse {
    cancelTmsTask: {
        success: boolean;
        code: string;
        message: string;
        argsJson?: string | null;
    };
}

export interface BatchPublishTmsTasksResponse {
    batchPublishTasks: Array<{
        id: string;
        taskNumber: string;
        taskType: number;
        taskDate: string;
        taskStatus: number;
        routeId: number;
        routeType?: number;
        planDepartureDate?: string;
        planDepartureTime?: string;
        actualDepartureDate?: string;
        actualDepartureTime?: string;
        actualDepartureAt?: string;
        planArrivalDate?: string;
        planArrivalTime?: string;
        actualArrivalDate?: string;
        actualArrivalTime?: string;
        actualArrivalAt?: string;
        carrierId: number;
        carrierName?: string;
        driverId: number;
        driverName?: string;
        vehicleId: number;
        licensePlate?: string;
        publishedAt?: string;
        completedAt?: string;
        createdAt?: string;
        updatedAt?: string;
    }>;
}

export interface HandleTmsWhsSealedScanEventInput {
    taskId: number;
    taskWayPointId: number;
    sealNumber: string;
    sealLocalTime?: string | null; // 封车时间（站点本地时间，格式 yyyy-MM-dd HH:mm）
    forceSubmit?: boolean; // 默认 false
    operationSource?: number; // 操作来源：1-APP司机端，2-PDA，3-PC服务端
}

export interface HandleTmsWhsSealedScanEventResponse {
    handleTmsWhsSealedScanEvent: {
        success: boolean;
        message: string;
        __typename: string;
    };
}

export interface HandleTmsWhsUnsealingScanEventInput {
    taskId: number;
    taskWayPointId: number;
    sealNumber: string;
    unSealLocalTime?: string | null; // 解封车时间（站点本地时间，格式 yyyy-MM-dd HH:mm）
    unSealInteriorPhotosJson?: string[] | null; // 解封车车内照片 S3 key 列表
    operationSource?: number; // 操作来源：1-APP司机端，2-PDA，3-PC服务端
}

export interface HandleTmsWhsUnsealingScanEventResponse {
    handleTmsWhsUnsealingScanEvent: {
        success: boolean;
        message: string;
        __typename?: string;
    };
}

export interface UpdateTmsTaskWaypointToArrivedInput {
    taskId: number;
    tmsTaskWayPointId: number;
    photosS3KeysJson: string[]; // 到达照片S3(此处命名问题，非S3KeysJson，是普通arrivalPhotosJson)     
    arrivalSealPhotosJson?: string[]; // 到达封签照片S3 key数组
    arrivedRemark?: string | null; // 到达备注
    accountId?: number; // 当前登录用户的账号ID
    isManagerUpdate?: boolean; // 是否是管理员修改
    actualArrivalLocalTime?: string | null;  // 实际到达本地时间(写库时需换算为UTC时间)
    operationSource?: number; // 操作来源：1-APP司机端，2-PDA，3-PC服务端
}

export interface UpdateTmsTaskWaypointToDepartureInput {
    taskId: number;
    tmsTaskWayPointId: number;
    departurePhotosJson?: string[] | null; // 发车照片S3 key数组
    departureSealPhotosJson?: string[] | null; // 发车封签照片S3 key数组
    departureRemark?: string | null; // 发车备注
    accountId?: number; // 当前登录用户的账号ID
    isManagerUpdate?: boolean; // 是否是管理员修改
    actualDepartureLocalTime?: string | null;  // 实际发车本地时间(写库时需换算为UTC时间)
    operationSource?: number; // 操作来源：1-APP司机端，2-PDA，3-PC服务端
}
